
import React, { useEffect, useState, Children, useContext} from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from "react-router-dom"
import Button from '../formfields/Button'
import Card from '../ui-elements/Card'
import { subscribe } from '../utils/pubsub'
import Spinner from '../ui-elements/Spinner'
import JsonDebug from '../ui-elements/JsonDebug'

type Props = {
    organisationId: string
    organisation: ObjectStringKeyAnyValue
}


function IndividualOrganisationSummary({
    organisationId,
    organisation
}: Props) {

    const {
        tableData,
        sendMessageToWebsocket
    } = useContext(GlobalContext)


    useEffect(() => {
        if (
            tableData &&
            tableData.Organisations &&
            tableData.Organisations[organisationId]
        ){

            fetchCheckPeriodSummary()
        }
    }, [tableData])


    const fetchCheckPeriodSummary = () => {
        if (!tableData.Organisations[organisationId].CheckPeriodSummary){
            const payload = JSON.stringify({
                action: "portal",
                subAction: "getCheckPeriodSummaryForOrg",
                organisationId: organisationId
            })
            sendMessageToWebsocket(payload)
        } else {
            //console.log(`${organisationId}: CheckPeriodSummary already exists for this organisation`)
        }

    }

    const summaryForThisOrg = tableData && tableData.Organisations && tableData.Organisations[organisationId] && tableData.Organisations[organisationId].CheckPeriodSummary

    return <Card fullwidth={true}>
        <div className={`w-full flex flex-col items-center justify-center gap-4`}>

            <h3 className={`text-2xl font-brandblue font-righteous`}>{organisation.OrganisationName}</h3>

            {!summaryForThisOrg && <Spinner>Loading...</Spinner>}

            {summaryForThisOrg && <div className={`border-t-2 border-gray-300 pt-3 flex flex-row gap-4 items-start text-center`}>
                <div className={``}>
                    <p className={`text-xs`}>Total check periods:</p>
                    <p className={`font-bold`}>{summaryForThisOrg.totalCheckPeriods}</p>
                </div>
                <div className={``}>
                    <p className={`text-xs`}>Completed check periods:</p>
                    <p className={`font-bold`}>{summaryForThisOrg.completedCheckPeriods}</p>
                </div>
                <div className={`
                ${parseInt(`${summaryForThisOrg.completedCheckPeriodPercentage}`) < 90 ?
                    " bg-red-100 text-red-600 " :
                    " bg-green-100 text-=green-600"}
                w-16 h-16 flex items-center justify-center text-center p-2`}
                style={{borderRadius: "50%"}}>
                    <p className={`text-xl font-righteous`}>{summaryForThisOrg.completedCheckPeriodPercentage}%</p>
                </div>
            </div>
            }

        </div>
    </Card>
}

export default IndividualOrganisationSummary